'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionYoutubeSearchedFor = function ActionYoutubeSearchedFor(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z' })
  );
};
ActionYoutubeSearchedFor = (0, _pure2.default)(ActionYoutubeSearchedFor);
ActionYoutubeSearchedFor.displayName = 'ActionYoutubeSearchedFor';
ActionYoutubeSearchedFor.muiName = 'SvgIcon';

exports.default = ActionYoutubeSearchedFor;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/youtube-searched-for.js
// module id = 2670
// module chunks = 0